var __jsx = React.createElement;
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-regular-svg-icons";
var CustomUserMessage = function CustomUserMessage(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start mb-4 last:mb-0 justify-end p-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-2 mt-2 rounded-lg max-w-[75%] bg-white text-gray-800 rounded-tr-none"
  }, /*#__PURE__*/React.createElement("p", {
    className: "p-2 whitespace-pre-wrap"
  }, props.message)), /*#__PURE__*/React.createElement("div", {
    className: "p-3 rounded-full bg-gray-700 flex items-center justify-center ml-3 flex-shrink-0"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUser,
    size: "lg",
    className: "text-white"
  }))));
};
export default CustomUserMessage;